import { render, staticRenderFns } from "./CaseTaskItem.vue?vue&type=template&id=74e5b6d2"
import script from "./CaseTaskItem.vue?vue&type=script&lang=js"
export * from "./CaseTaskItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports